(function () {
  function initMeeoowUi($) {
    $(function () {
      document.querySelectorAll('.heading_with_icons_custom_drop').forEach(function (element) {
        element.addEventListener('click', function () {
          this.classList.toggle('active');
          document.querySelector('.benifi_drop_content_bs_custom_drop')?.classList.toggle('active');
        });
      });

      $('.head_click_whole_section_drop_down').on('click', function () {
        $(this).closest('.image_wuth_text_bs_fund_new_bs').toggleClass('active');
      });

      var $slider = $('.swiper.iscardimages');
      if ($slider.length && !$slider.hasClass('slick-initialized')) {
        var $progressBar = $('.progress');
        var $progressBarLabel = $('.slider__label');

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var calc = (nextSlide / (slick.slideCount - 1)) * 100;
          $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
          $progressBarLabel.text(calc + '% completed');
        });

        $slider.slick({
          dots: false,
          arrows: false,
          infinite: true,
          autoplay: false,
          autoplaySpeed: 2000,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    });
  }

  function initBlogProductCards() {
    var anchorTags = document.querySelectorAll('.product_link_with_blog_new:not(.product_link)');
    if (!anchorTags.length) {
      return;
    }

    var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    anchorTags.forEach(function (anchor) {
      var span = anchor.querySelector('span');
      var producturlnew = span ? span.textContent : '';
      var productId = (producturlnew.trim() || '').split('?')[0];
      var href = anchor.getAttribute('href') || '';

      if (productId) {
        fetch(routesRoot + 'products/' + productId + '.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (product) {
            if (!product.images || !product.images.length) {
              return;
            }

            var pdt_price = parseFloat((product.price / 100).toFixed(2));
            var image = product.images[0];

            if (anchor.parentElement) {
              anchor.parentElement.classList.add('pb-custom-code', 'center-akhil');
            }

            anchor.insertAdjacentHTML(
              'beforeend',
              '<a href="https://faithandpatience.co.in/products/' +
                producturlnew +
                '" class="anchor-for-product-page-akhil"><img loading="lazy" src="' +
                image +
                '" class="product_image_bs_blog" width="400" height="400" alt="' +
                (product.title || '').replace(/"/g, '&quot;') +
                '"/></a>' +
                '<a href="https://faithandpatience.co.in/products/' +
                producturlnew +
                '" class="anchor-for-product-page-akhil"><p class="blogs-pages-product-title_ak">' +
                product.title +
                '</p></a>' +
                '<p class="blogs-pages-product-price_ak">Rs.' +
                pdt_price +
                '</p>' +
                '<button type="button" value="' +
                product.variants[0].id +
                '" class="pb-cart button blogs-pages-product-btn_ak">Add to cart</button>'
            );
          })
          .catch(function () {});

        anchor.classList.add('product_link');
        anchor.style.display = 'block';
      } else if (href.indexOf('dietplans.faithandpatience.co.in/pages/') !== -1) {
        anchor.classList.add('product_link');
        anchor.style.color = 'white';
      } else if (href.indexOf('support.faithandpatience.co.in/pages/') !== -1) {
        anchor.classList.add('product_link');
        anchor.style.margin = 'auto';
      }
    });
  }

  function bindBlogCartClicks() {
    if (window.__fpBlogCartBound) {
      return;
    }
    window.__fpBlogCartBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('button.pb-cart.blogs-pages-product-btn_ak');
      if (!button) {
        return;
      }

      event.preventDefault();
      var variantId = button.getAttribute('value');
      if (!variantId) {
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          quantity: 1,
          id: variantId
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var cartCount = document.querySelector('#CartCount span');
          if (cartCount && data.quantity != null) {
            cartCount.textContent = data.quantity;
          }
          window.location.href = '/cart';
        })
        .catch(function () {});
    });
  }

  function runBlogProductEmbed() {
    initBlogProductCards();
    bindBlogCartClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBlogProductEmbed, { once: true });
  } else {
    runBlogProductEmbed();
  }

  if (window.FP && window.FP.ready) {
    window.FP.ready(initMeeoowUi);
  } else if (window.jQuery) {
    initMeeoowUi(window.jQuery);
  }
})();
